export default "__VITE_ASSET__Bc1uOTYR__"